import React, { useEffect, useState } from 'react'
import './ActivateAccount.css'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown'

import { useSelector, useDispatch } from 'react-redux'
import { updateAccountActivateData } from '../../../actions'

const SecurityQuestion = (props) => {

  const dispatch = useDispatch()
  const accountActivateData = useSelector(state => state.accountActivateReducers)
  const challengeQuestions = useSelector(state => state.challengeQuestionsReducers)

  const [invalid, setInvalid] = useState({
    answer1: false,
    answer2: false,
    answer3: false,
    answer2unique: false,
    answer3unique: false
  })

  const resetValidation = (fields) => {
    var fieldsUpdate = {}
    if (typeof (fields) === 'string') {
      fieldsUpdate[`${fields}`] = false
    } else if (Array.isArray(fields)) {
      fields.forEach(item => {
        fieldsUpdate[`${item}`] = false
      })
    }
    setInvalid(Object.assign({}, invalid, fieldsUpdate))
  }

  const validateOnSubmit = () => {
    var allowSubmit = true;
    var invalidJSON = {}

    if (accountActivateData.data.answer1 === null) {
      Object.assign(invalidJSON, { answer1: true })
      allowSubmit = false
    }

    if (accountActivateData.data.answer2 === null) {
      Object.assign(invalidJSON, { answer2: true })
      allowSubmit = false
    }

    if (accountActivateData.data.answer3 === null) {
      Object.assign(invalidJSON, { answer3: true })
      allowSubmit = false
    }
    if (accountActivateData.data.answer1 !== null && accountActivateData.data.answer2 !== null) {
      if (accountActivateData.data.answer1 === accountActivateData.data.answer2) {
        Object.assign(invalidJSON, { answer2unique: true })
        allowSubmit = false
      }
    }

    if (accountActivateData.data.answer1 !== null && accountActivateData.data.answer3 !== null) {
      if (accountActivateData.data.answer1 === accountActivateData.data.answer3) {
        Object.assign(invalidJSON, { answer3unique: true })
        allowSubmit = false
      }
    }

    if (accountActivateData.data.answer2 !== null && accountActivateData.data.answer3 !== null) {
      if (accountActivateData.data.answer2 === accountActivateData.data.answer3) {
        Object.assign(invalidJSON, { answer3unique: true })
        allowSubmit = false
      }
    }

    if (allowSubmit) {
      props.setActiveIndex(2)
    } else {
      setInvalid(Object.assign({}, invalid, invalidJSON))
    }
  }

  useEffect(() => {
  }, [])

  return <div>

    <div className="activate-account-card">
      <div className="center">
        <div><hr className="divider-line" /></div>

        <div className="security-question-title">Security questions are required to reset your password. Choose questions you can remember.</div>

        < div className="security-question-inner">
          <div>
            <div className="label">Question 1</div>
            <div><Dropdown
              options={challengeQuestions.data.questions.filter(item => item.value !== accountActivateData.data.question2 && item.value !== accountActivateData.data.question3)}
              placeholder="Select a question"
              value={accountActivateData.data.question1}
              onChange={(e) => {
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { question1: e.value })))
              }} />
            </div>
            <div className="answer-container">
              <InputText placeholder="Answer" value={accountActivateData.data.answer1 || ''} onChange={(e) => {
                resetValidation('answer1')
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { answer1: e.target.value !== '' ? e.target.value : null })))
              }} />
            </div>
            {invalid.answer1 ? <small> <div className="p-error top-margin">Answer to question 1 is required</div></small> : null}
          </div>

          <div>
            <div className="label">Question 2</div>
            <div><Dropdown
              options={challengeQuestions.data.questions.filter(item => item.value !== accountActivateData.data.question1 && item.value !== accountActivateData.data.question3)}
              placeholder="Select a question"
              value={accountActivateData.data.question2}
              onChange={(e) => {
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { question2: e.value })))
              }} />
            </div>
            <div className="answer-container">
              <InputText placeholder="Answer" value={accountActivateData.data.answer2 || ''} onChange={(e) => {
                resetValidation(['answer2', 'answer2unique'])
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { answer2: e.target.value !== '' ? e.target.value : null })))
              }} />
            </div>
            {invalid.answer2 ? <small> <div className="p-error top-margin">Answer to question 2 is required</div></small> : null}
            {invalid.answer2unique ? <small> <div className="p-error top-margin">Answer to question 2 was repeated</div></small> : null}
          </div>

          <div>
            <div className="label">Question 3</div>
            <div><Dropdown
              options={challengeQuestions.data.questions.filter(item => item.value !== accountActivateData.data.question1 && item.value !== accountActivateData.data.question2)}
              placeholder="Select a question"
              value={accountActivateData.data.question3}
              onChange={(e) => {
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { question3: e.value })))
              }} />
            </div>
            <div className="answer-container">
              <InputText placeholder="Answer" value={accountActivateData.data.answer3 || ''} onChange={(e) => {
                resetValidation(['answer3', 'answer3unique'])
                dispatch(updateAccountActivateData(Object.assign({}, accountActivateData.data, { answer3: e.target.value !== '' ? e.target.value : null })))
              }} />
            </div>
            {invalid.answer3 ? <small> <div className="p-error top-margin">Answer to question 3 is required</div></small> : null}
            {invalid.answer3unique ? <small> <div className="p-error top-margin">Answer to question 3 was repeated</div></small> : null}
          </div>
          <br />
          <div className="row-btn"><div className="row-btn-link"><Button onClick={() => {
            validateOnSubmit()
            //props.setActiveIndex(2)
          }
          }>Next</Button></div></div>
          <div className="row-btn back-btn">
            <span onClick={() => {
              props.setValidateRecapt(null)
              props.setActiveIndex(null)
            }} className="row-btn-link">Back</span>
          </div>
        </div>
      </div>
    </div>

  </div >

}

export default SecurityQuestion